import React, {Component} from 'react';
import { Link } from "react-router-dom";

export default class Footer extends Component {
    render() {
        return (
            <div className={'footer'}>
                &#160;&#160;
                <Link to={'/privacy'} target={'_blank'} rel={'nofollow'}>Privacy</Link>
                &#160;|&#160; 
                <Link to={'/imprint'} target={'_blank'} rel={'nofollow'}>Imprint</Link>
                <br/>
                &#169;
                Copyright <a rel={'noreferrer'} href={'https://maxerler.de'}>Max Erler</a> {new Date().getFullYear()}
            </div>
        );
    }
}
